<template>
  <div class="center">
    <button v-show="more" @click="load()" class="btn btn-white"><i class="fa fa-plus"></i> Carregar mais {{limit}} registros</button>
    <span v-show="!more">Não há mais registros</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      limit: 10,
      pageNumber: this.page
    }
  },
  props: {
    more: true,
    page: 0,
  },
  methods: {
    load(pageNumber) {
      this.pageNumber ++
      this.$emit('paginate', { page: this.pageNumber, limit: this.limit })
    }
  },
  watch: {
    page(newValue) {
      this.pageNumber = newValue
    }
  }
}
</script>

<style scoped>
  .center { text-align: center; padding-top: 20px; }
  .btn { padding-left: 15px; padding-right: 15px; }
</style>



// WEBPACK FOOTER //
// src/components/PaginationLinks.vue